// extracted by mini-css-extract-plugin
module.exports = {"aboutBlock":"about-block_aboutBlock__SoszI","lead":"about-block_lead___9PKQ"};